var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondExclaimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "emergency_home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_6412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_6412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "emergency_home_2",
    d: "M10.0002 18.3543C9.77794 18.3543 9.56614 18.3127 9.36475 18.2293C9.16336 18.146 8.97933 18.0279 8.81266 17.8752L2.12516 11.1877C1.97238 11.021 1.85433 10.837 1.771 10.6356C1.68766 10.4342 1.646 10.2224 1.646 10.0002C1.646 9.77794 1.68766 9.56266 1.771 9.35433C1.85433 9.146 1.97238 8.96544 2.12516 8.81266L8.81266 2.12516C8.97933 1.9585 9.16336 1.83697 9.36475 1.76058C9.56614 1.68419 9.77794 1.646 10.0002 1.646C10.2224 1.646 10.4377 1.68419 10.646 1.76058C10.8543 1.83697 11.0349 1.9585 11.1877 2.12516L17.8752 8.81266C18.0418 8.96544 18.1634 9.146 18.2397 9.35433C18.3161 9.56266 18.3543 9.77794 18.3543 10.0002C18.3543 10.2224 18.3161 10.4342 18.2397 10.6356C18.1634 10.837 18.0418 11.021 17.8752 11.1877L11.1877 17.8752C11.0349 18.0279 10.8543 18.146 10.646 18.2293C10.4377 18.3127 10.2224 18.3543 10.0002 18.3543ZM10.0002 16.6877L16.6877 10.0002L10.0002 3.31266L3.31266 10.0002L10.0002 16.6877ZM9.16683 10.8335H10.8335V5.8335H9.16683V10.8335ZM10.0002 13.3335C10.2363 13.3335 10.4342 13.2536 10.5939 13.0939C10.7536 12.9342 10.8335 12.7363 10.8335 12.5002C10.8335 12.2641 10.7536 12.0661 10.5939 11.9064C10.4342 11.7467 10.2363 11.6668 10.0002 11.6668C9.76405 11.6668 9.56614 11.7467 9.40641 11.9064C9.24669 12.0661 9.16683 12.2641 9.16683 12.5002C9.16683 12.7363 9.24669 12.9342 9.40641 13.0939C9.56614 13.2536 9.76405 13.3335 10.0002 13.3335Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondExclaimation);
export default __webpack_public_path__ + "static/media/diamond_exclaimation.18a2a9c731b6c03fb2446021353d4c2a.svg";
export { ForwardRef as ReactComponent };